// extracted by mini-css-extract-plugin
module.exports =  {"root":"kgiVxDyCb9RQ5MUIiDl5","spinner":"SZzwTtNAxyZ3CYcYHXqL","rotator":"kb62WA6bj1YZ5BkbDTcJ","path":"n_IhzXal9NwU61NC2ksP","dash":"LsA1WQShsUOlSoTIzP_8"};